import * as IconComponents from "./components"

export { IconComponents }
export { iconsList } from "./iconsList"
export * from "./icon"
